import { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import CKEditor from '../ckeditor4';
import ArrowButton from '../../button-arrow';
import { saveTextContent } from '../../../../actions/content';
import CKEditorConfig from '../../../../data/CKEditor';
import { getEnvironmentVariable } from '../../../../actions/environment-variable';

import './styles.css';

class InlineCKEditor extends Component {
  state = {
    content: '',
    identifier: ''
  };

  updateContent = (newContent) => {
    this.setState({
      content: newContent
    });
  };

  onSaveContent = () => {
    this.props.dispatch(saveTextContent(this.state.identifier, this.state.content))
      .then(() => {
        if (typeof this.props.onContentSaved === 'function') {
          this.props.onContentSaved();
        }
      });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.identifier && nextProps.contents) {
      this.setState({
        identifier: nextProps.identifier,
        content: nextProps.contents.body || this.state.content || ''
      });
    }
  }

  UNSAFE_componentWillMount() {
    this.setState({
      identifier: this.props.identifier,
      content: this.props.contents ? this.props.contents.body : ''
    });
    if (this.isLicenseKeyLoading()) {
      this.props.dispatch(getEnvironmentVariable('REACT_APP_CKEDITOR_LICENSE_KEY'));
    }
  }

  isLicenseKeyLoading = () => {
    const { licenseKey } = this.props;

    if (!licenseKey) {
      return true;
    }

    return licenseKey.length === 0;
  }

  render() {
    const { editContent, activeClass, config } = this.props;
    const { content } = this.state;
    const renderedContent = content ? <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content)}}/> : '';

    if (this.isLicenseKeyLoading() && editContent) {
      return (
        <div>Loading editor...</div>
      );
    }

    return (
      <div className="inline-editor">
        {editContent ? (
          <div>
            <CKEditor
              content={content}
              activeClass={activeClass}
              scriptUrl="/api/ckeditor/ckeditor.js"
              config={{
                ...CKEditorConfig,
                ...config,
                versionCheck: false,
                licenseKey: this.props.licenseKey
              }}
              events={{
                change: event => this.updateContent(event.editor.getData())
              }}
            />
            <div className="mg-top-40">
              <ArrowButton
                arrow={false}
                submit={false}
                onClick={this.onSaveContent}
              >
                Save
              </ArrowButton>
            </div>
          </div>
        ) : renderedContent}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  editContent: state.viewConfig.editContent,
  licenseKey: state.environmentVariable.environmentVariableValue
});

export default connect(mapStateToProps)(InlineCKEditor);
